import React from 'react';
import { ZapIcon, LeafIcon, HeartPulseIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="w-full bg-stone-50 py-16 md:py-20" data-id="element-553">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-555">
          How It Works
        </h2>

        <div className="grid md:grid-cols-3 gap-10 md:gap-8" data-id="element-556">
          {/* Step 1 */}
          <div className="text-center" data-id="element-557">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-558">
              <ZapIcon className="w-7 h-7 text-emerald-700" data-id="element-559" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-560">
              Step 1
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-561">
              Instant Access
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-562">
              After purchase, you'll immediately receive the Natural Remedy
              Survival Guide and both bonus guides as downloadable PDFs.
            </p>
          </div>

          {/* Step 2 */}
          <div className="text-center" data-id="element-563">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-564">
              <LeafIcon className="w-7 h-7 text-emerald-700" data-id="element-565" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-566">
              Step 2
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-567">
              Start With Common Remedies
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-568">
              Learn how to prepare simple natural remedies using ingredients you
              likely already have in your kitchen or can easily find at any
              grocery store.
            </p>
          </div>

          {/* Step 3 */}
          <div className="text-center" data-id="element-569">
            <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-570">
              <HeartPulseIcon className="w-7 h-7 text-emerald-700" data-id="element-571" />
            </div>
            <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2" data-id="element-572">
              Step 3
            </p>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-573">
              Support Your Body Naturally
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-574">
              Use the guide as your everyday reference for immunity, digestion,
              sleep, inflammation, and natural first aid.
            </p>
          </div>
        </div>
      </div>
    </section>;
}